import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { CRONJOBS } from '../enums';

@Pipe({
  name: 'cronjobs'
})
export class CronjobsPipe extends EnumConverter implements PipeTransform {
  enumeration = CRONJOBS;
}
